import { render, staticRenderFns } from "./administratorSettings.vue?vue&type=template&id=0d9f5d18&scoped=true"
import script from "./administratorSettings.vue?vue&type=script&lang=js"
export * from "./administratorSettings.vue?vue&type=script&lang=js"
import style0 from "./administratorSettings.vue?vue&type=style&index=0&id=0d9f5d18&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9f5d18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d9f5d18')) {
      api.createRecord('0d9f5d18', component.options)
    } else {
      api.reload('0d9f5d18', component.options)
    }
    module.hot.accept("./administratorSettings.vue?vue&type=template&id=0d9f5d18&scoped=true", function () {
      api.rerender('0d9f5d18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/systemManagement/administratorSettings/administratorSettings.vue"
export default component.exports